<template>
  <div class="main">
    <el-dialog
      @close="close"
      append-to-body
      :visible.sync="dialogVisible"
      top="1.5rem"
      modal
      modal-append-to-body
      width="92%"
      center
    >
      <template>
        <div class="closeIcon" @click="close">
          <img src="@/assets/mobile/close-icon.png" alt="" />
        </div>
        <div class="publicConsultation">
          <div class="title" v-if="['zh', 'en'].includes($i18n.locale)">
            <span>{{ $t('publicConsultation.title1') }}</span>
            <span class="active">{{ $t('publicConsultation.title2') }}</span>
            <span>{{ $t('publicConsultation.title3') }}</span>
          </div>
          <div class="title" v-if="['es', 'id'].includes($i18n.locale)">
            <span>{{ $t('publicConsultation.title3') }}</span>
            <span>{{ $t('publicConsultation.title1') }}</span>
            <span class="active">{{ $t('publicConsultation.title2') }}</span>
          </div>

          <el-form ref="form" :model="form" :rules="rules">
            <div class="left">
              <el-form-item prop="productActive">
                <template slot="label">
                  <span class="checkTitle">
                    {{ $t('publicConsultation.productGroup') }}
                  </span>
                </template>
                <div class="checkGroup">
                  <div
                    class="checkItem"
                    @click="changeProduct(item.id)"
                    v-for="(item, index) in checkList"
                    :key="index"
                  >
                    <div class="info">
                      <img :src="item.icon" alt="" />
                      <span>{{ $t(`publicConsultation.${item.name}`) }}</span>
                    </div>
                    <div class="select">
                      <img
                        v-if="!form.productActive.includes(item.id)"
                        src="@/assets/PC/publicConsultation/default.png"
                        alt=""
                      />
                      <img
                        v-else
                        src="@/assets/PC/publicConsultation/acitive.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="right">
              <el-form-item prop="companyName">
                <template slot="label">
                  <span class="checkTitle">{{
                    $t('publicConsultation.form.companyName')
                  }}</span>
                </template>
                <el-input
                  v-model="form.companyName"
                  :placeholder="$t('el.pleaseEnter')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="contactPersonName">
                <template slot="label">
                  <span class="checkTitle">{{
                    $t('publicConsultation.form.contactPersonName')
                  }}</span>
                </template>
                <el-input
                  v-model="form.contactPersonName"
                  :placeholder="$t('el.pleaseEnter')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="contactPersonPhone">
                <template slot="label">
                  <span class="checkTitle">{{
                    $t('publicConsultation.form.contactPersonPhone')
                  }}</span>
                </template>
                <el-input
                  v-model="form.contactPersonPhone"
                  :placeholder="$t('el.pleaseEnter')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="descriptionOfNeeds">
                <template slot="label">
                  <span class="checkTitle">{{
                    $t('publicConsultation.form.descriptionOfNeeds')
                  }}</span>
                </template>
                <el-input
                  type="textarea"
                  v-model="form.descriptionOfNeeds"
                  :placeholder="$t('el.pleaseEnter')"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="submitTip" @click="isConfirm = !isConfirm">
            <div class="imgs">
              <img
                v-if="!isConfirm"
                src="@/assets/PC/publicConsultation/default.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/PC/publicConsultation/acitive.png"
                alt=""
              />
            </div>
            <span>{{ $t('publicConsultation.submitTip') }}</span>
          </div>

          <div class="submitBtnBg">
            <div class="submitBtn" @click="submit">{{ $t('el.submit') }}</div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import rules from '@/rules'
export default {
  data () {
    return {
      rules,
      dialogVisible: true,
      checkList: [
        {
          name: 'item1',
          icon: require('@/assets/PC/publicConsultation/checkItem-AI-Ads.png'),
          id: 1
        },
        {
          name: 'item2',
          icon: require('@/assets/PC/publicConsultation/checkItem-EKYC.png'),
          id: 2
        },
        {
          name: 'item3',
          icon: require('@/assets/PC/publicConsultation/checkItem-Luna-AI-Robot.png'),
          id: 3
        },
        {
          name: 'item4',
          icon: require('@/assets/PC/publicConsultation/checkItem-Anti-Fraud-Services.png'),
          id: 4
        },
        {
          name: 'item5',
          icon: require('@/assets/PC/publicConsultation/checkItem-Credit-Scoring-Services.png'),
          id: 5
        }
      ],
      form: {
        productActive: [],
        companyName: '',
        contactPersonName: '',
        contactPersonPhone: '',
        descriptionOfNeeds: ''
      },
      isConfirm: true
    }
  },
  methods: {
    changeProduct (id) {
      const activeIndex = this.form.productActive.indexOf(id)
      if (activeIndex === -1) {
        this.form.productActive.push(id)
      } else {
        this.form.productActive.splice(activeIndex, 1)
      }
    },
    submit () {
      this.$refs.form.validate(async (valid) => {
        if (valid && this.isConfirm) {
          let productText = 'Products: '
          this.form.productActive.forEach((item, indx) => {
            this.checkList.forEach((subItem, subIndex) => {
              if (item === subItem.id) {
                productText = productText + `${this.$t(`publicConsultation.item${subItem.id}`)} / `
              }
            })
          })
          const companyName = `Company Name: ${this.form.companyName}`
          const contactPersonName = `Name: ${this.form.contactPersonName}`
          const contactPersonPhone = `Phone: ${this.form.contactPersonPhone}`
          const descriptionOfNeeds = `Needs: ${this.form.descriptionOfNeeds}`
          const emailBody =
            `
            ${productText}\n
            ${companyName}\n
            ${contactPersonName}\n
            ${contactPersonPhone}\n
            ${descriptionOfNeeds}
          `
          const subject = 'Consult products and services of CloudunAI'
          const mailLink = `mailto:operation@cloudun.ai?subject=${subject}&body=` + encodeURIComponent(emailBody)
          window.location.href = mailLink
          this.close()
        }
      })
    },
    close () {
      this.form = {
        productActive: [],
        companyName: '',
        contactPersonName: '',
        contactPersonPhone: '',
        descriptionOfNeeds: ''
      }
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  border-radius: 0.4rem;

  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    position: relative !important;
  }
}
.publicConsultation {
  border-radius: 0.4rem;
  max-height: 15rem;
  overflow: auto;
  position: relative;
  .title {
    background-color: #fff;
    position: sticky;
    top: 0;
    height: 1.92rem /* 72/37.5 */;
    background-image: url('@/assets/PC/publicConsultation/publicConsultation-bgi.png');
    background-size: cover;
    background-position: center;
    border-radius: 0.4rem 0.4rem 0 0;
    padding: 0.48rem /* 18/37.5 */ 1.4rem /* 40/37.5 */;
    text-align: center;
    z-index: 99;

    span {
      color: #242b2a;
      font-weight: 700;
      font-size: 0.426667rem /* 16/37.5 */;
      line-height: 0.506667rem /* 19/37.5 */;
    }
    .active {
      color: #07816a;
    }
  }
  .el-form {
    width: 100%;
    padding: 0.533333rem /* 20/37.5 */ 0.426667rem /* 16/37.5 */ 0.266667rem;
  }
}
.closeIcon {
  position: absolute;
  bottom: -0.32rem;
  left: 50%;
  transform: translateX(-50%) translateY(100%);
  width: 0.8rem;
  height: 0.8rem;
  z-index: 999;
  img {
    width: 0.8rem;
    height: 0.8rem;
  }
}
/deep/ .el-form-item__label {
  color: #242b2a;
  font-weight: 500;
  font-size: 0.373333rem /* 14/37.5 */;
  font-weight: 500;
  text-align: left;
  line-height: 0.426667rem /* 16/37.5 */;
  width: 100%;
  margin-bottom: 0.426667rem /* 16/37.5 */;
}
.checkGroup {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  .checkItem {
    width: 48%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #f3f3f3;
    border-radius: 1.066667rem /* 40/37.5 */;
    padding: 0.08rem;
    margin-top: 0.266667rem /* 10/37.5 */;
    &:last-child {
      width: 100%;
    }
    &:nth-child(1),
    &:nth-child(2) {
      margin-top: 0;
    }
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      img {
        width: 1.066667rem /* 40/37.5 */;
        height: 1.066667rem /* 40/37.5 */;
        margin-right: 0.213333rem /* 8/37.5 */;
      }
      span {
        color: #242b2a;
        font-size: 0.32rem;
        font-weight: 400;
        font-size: 0.32rem /* 12/37.5 */;
        line-height: 0.373333rem /* 14/37.5 */;
      }
    }
    .select {
      display: flex;
      align-items: center;
      img {
        width: 0.533333rem /* 20/37.5 */;
        height: 0.533333rem /* 20/37.5 */;
      }
    }
  }
}
/deep/ .el-form-item__content {
  margin-bottom: 0.4rem;
}
/deep/ .el-input__inner {
  border: 1px solid #f3f3f3;
  border-radius: 0.8rem;
  height: 1.12rem;
  &::placeholder {
    color: rgba(36, 43, 42, 0.2);
    font-size: 0.373333rem /* 14/37.5 */;
    font-weight: 400;
  }
}
/deep/ .el-textarea__inner {
  border: 1px solid #f3f3f3;
  &::placeholder {
    color: rgba(36, 43, 42, 0.2);
    font-size: 0.373333rem /* 14/37.5 */;
    font-weight: 400;
  }
}

.submitTip {
  display: flex;
  padding: 0 0.6rem 0 0.426667rem /* 16/37.5 */;
  margin-bottom: 0.533333rem /* 20/37.5 */;
  .imgs {
    margin-right: 0.24rem /* 9/37.5 */;
    img {
      width: 0.373333rem /* 14/37.5 */;
      height: 0.373333rem /* 14/37.5 */;
    }
  }
  span {
    color: rgba(36, 43, 42, 0.6);
    font-size: 0.266667rem /* 10/37.5 */;
    line-height: 0.4rem /* 15/37.5 */;
    text-align: left;
    font-weight: 400;
  }
}

.submitBtnBg {
  background-color: #ffffff;
  width: 100%;
  position: sticky;
  bottom: 0;
  padding: 0.266667rem /* 10/37.5 */ 0;
  z-index: 99;
  .submitBtn {
    height: 1.066667rem /* 40/37.5 */;
    background-color: #242b2a;
    border-radius: 0.64rem;
    padding: 0.34rem 1.54rem;
    display: table;
    color: #ffffff;
    font-size: 0.426667rem /* 16/37.5 */;
    font-weight: 500;
    font-weight: 500;
    margin: auto;
  }
}
</style>
